import {Component, OnInit} from '@angular/core';
import {SidenavItem} from '../sidenav/sidenav-item/sidenav-item.model';
import * as fromRoot from '../../reducers/index';
import * as fromSidenav from '../sidenav/shared/sidenav.action';
import {SetCurrentlyOpenByRouteAction} from '../sidenav/shared/sidenav.action';
import {Store} from '@ngrx/store';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SelectLayoutAction, SetCardElevationAction} from '../layout/shared/layout.action';

@Component({
    selector: 'vr-route-handler',
    templateUrl: './route-handler.component.html',
    styleUrls: ['./route-handler.component.scss']
})
export class RouteHandlerComponent implements OnInit {

    constructor(
        private store: Store<fromRoot.State>,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        // Set Sidenav Currently Open on Page load
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.store.dispatch(new SetCurrentlyOpenByRouteAction(event.urlAfterRedirects));
            }
        });

        // You can use ?layout=beta to load the page with Layout Beta as default
        // Same with ?elevation=5 (anything from 0 to 24)
        this.route.queryParamMap.subscribe((params) => {
            const layout = params.get('layout');

            switch (layout) {
                case 'alpha': {
                    this.store.dispatch(new SelectLayoutAction('alpha'));
                    break
                }

                case 'beta': {
                    this.store.dispatch(new SelectLayoutAction('beta'));
                    break
                }

                case 'gamma': {
                    this.store.dispatch(new SelectLayoutAction('gamma'));
                    break
                }
            }

            const elevation = params.get('elevation');

            if (elevation) {
                this.store.dispatch(new SetCardElevationAction('card-elevation-z' + elevation))
            }
        });

        // Define Menu Items here

        const home = new SidenavItem({
            name: 'Home',
            icon: 'home',
            route: '/',
            subItems: [],
            position: 1
        });
        const usermanagement = new SidenavItem({
            name: 'User Management',
            icon: 'people',
            subItems: [],
            position: 2
        });

        const coldstore = new SidenavItem({
            name: 'Cold Store',
            route: '/cold-store',
            parent: usermanagement,
            subItems: [],
            position: 3
        });
        const escalation = new SidenavItem({
            name: 'Performance',
            route: '/performance',
            parent: usermanagement,
            subItems: [],
            position: 4
        });
        const region = new SidenavItem({
            name: 'Region',
            route: '/region',
            parent: usermanagement,
            subItems: [],
            position: 5
        });
        const site = new SidenavItem({
            name: 'Site',
            route: '/site',
            parent: usermanagement,
            subItems: [],
            position: 6
        });

        const operator = new SidenavItem({
            name: 'User',
            route: '/user',
            parent: usermanagement,
            subItems: [],
            position: 7
        });
        /*   const vendor = new SidenavItem({
             name: 'Vendor',
             route: '/vendor',
             parent: usermanagement,
             subItems: [],
             position: 3
         });
         const client = new SidenavItem({
             name: 'Client',
             route: '/client',
             parent: usermanagement,
             subItems: [],
             position: 4
         });*/
        /*   const deviationType = new SidenavItem({
           name: 'Deviation History',
           route: '/deviation-history',
           parent: usermanagement,
           subItems: [],
           position: 7
       });*/
       /* usermanagement.subItems.push(vendor);
        usermanagement.subItems.push(client);*/
        usermanagement.subItems.push(coldstore);
        usermanagement.subItems.push(escalation);


/*        usermanagement.subItems.push(deviationType);*/
        usermanagement.subItems.push(region);
        usermanagement.subItems.push(site);
        usermanagement.subItems.push(operator);
        const settings = new SidenavItem({
            name: 'Settings',
            icon: 'settings',
            subItems: [],
            position: 1
        });


    /*    const role = new SidenavItem({
            name: 'Assign Permission',
            route: '/settings/roles',
            subItems: [],
            parent: settings,
            position: 3
        });
        const users = new SidenavItem({
            name: 'Assign Role',
            route: '/settings/users',
            subItems: [],
            parent: settings,
            position: 4
        });*/
        const commodity = new SidenavItem({
            name: 'Food Type',
            route: '/settings/food-type',
            subItems: [],
            parent: settings,
            position: 2
        });
        const profile = new SidenavItem({
            name: 'Profile',
            route: '/settings/profile',
            subItems: [],
            parent: settings,
            position: 3
        });
        const profiletype = new SidenavItem({
            name: 'Cold Store Type',
            route: '/settings/profile-type',
            subItems: [],
            parent: settings,
            position: 4
        });
/*        const roles = new SidenavItem({
            name: 'Roles',
            route: '/settings/all-roles',
            subItems: [],
            parent: settings,
            position: 7
        });*/
        settings.subItems.push(commodity);
        settings.subItems.push(profile);
        /*settings.subItems.push(role);
        settings.subItems.push(users);*/

        settings.subItems.push(profiletype);
        // settings.subItems.push(roles);

        // Send the created Menu structure to Redux/ngrx (you only need to send the Top Level Item, all dropdown items will be added automatically)
        this.store.dispatch(new fromSidenav.AddSidenavItemAction(home));
        this.store.dispatch(new fromSidenav.AddSidenavItemAction(usermanagement));
        this.store.dispatch(new fromSidenav.AddSidenavItemAction(settings));

    }

}
